import styled from "../../styled";
import { inputStyles } from './inputStyles';
import { themeLss } from "../../lss";
export var Input = styled.input(inputStyles, themeLss());